// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';
import { getSentryEnvironment } from '@erikdakoda/log/sentryEnvironment';

if (process.env.NEXT_PUBLIC_SENTRY_ENABLED === 'true') {
  Sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    environment: getSentryEnvironment(),
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
      Sentry.browserProfilingIntegration(),
    ],
    tracesSampleRate: parseFloat(process.env.NEXT_PUBLIC_TRACES_SAMPLE_RATE || '1.0'),
    replaysSessionSampleRate: parseFloat(
      process.env.NEXT_PUBLIC_REPLAYS_SESSION_SAMPLE_RATE || '1.0',
    ),
    replaysOnErrorSampleRate: parseFloat(
      process.env.NEXT_PUBLIC_REPLAYS_ON_ERROR_SAMPLE_RATE || '1.0',
    ),
    profileSessionSampleRate: parseFloat(
      process.env.NEXT_PUBLIC_PROFILE_SESSION_SAMPLE_RATE || '1.0',
    ),
    debug: false,
  });
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
